<template>
    <div
        :class="classes"
        @click="handleClick"
    >
        <CoreRadio
            :id="item.id"
            :modelValue="modelValue"
            :optionValue="item.id"
            :name="radioGroupName"
            :label="item.name"
        />
        <span
            v-for="col in columns"
            :key="col.field"
        >
            {{ item[col.field] ?? (col.fallback ? $t(col.fallback) : '—') }}
        </span>
    </div>
</template>

<script>
import CoreRadio from '@/components/core/CoreRadio.vue'

export default {
    name: 'ItemRow',

    components: { CoreRadio },

    props: {
        modelValue: {
            type: [String, Number],
            default: null,
        },

        item: {
            type: Object,
            required: true,
        },

        radioGroupName: {
            type: String,
            required: true,
        },

        columns: {
            type: Array,
            default: () => [
                {
                    label: '§eq_type.model_year',
                    field: 'model_year',
                    fallback: '§eq_type.model_year_not_set',
                },
            ],
        },
    },

    emits: ['update:modelValue'],

    computed: {
        classes() {
            return {
                'mb-3': true,
                'select-item-row': true,
                'select-item-row--selected': this.item.id === this.modelValue,
                [`select-item-row--cols-${this.columns.length + 1}`]: true,
            }
        },
    },

    methods: {
        handleClick() {
            this.$emit('update:modelValue', this.item.id)
        },
    },
}
</script>

<style scoped>
.select-item-row {
    border: 1px solid var(--color-neutral-500);
    outline: 1px solid transparent;
    border-radius: 8px;

    padding: 16px;

    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;

    & > span {
        color: var(--color-secondary-200);
    }

    &.select-item-row--cols-2 > div,
    &.select-item-row--cols-2 > span {
        flex: 1 1 50%;
    }

    &.select-item-row--cols-3 > div,
    &.select-item-row--cols-3 > span {
        flex: 1 1 33%;
    }

    &.select-item-row--selected {
        outline: 1px solid var(--color-neutral-500);
    }

    &:hover {
        outline: 1px solid var(--color-neutral-500);
        cursor: pointer;
    }
}
</style>
